const ROLES = {
    VQPL: '164caf15f3464de7fb3ccb9601a55b1e',
    VDPL: 'e82e89f0bb71f67f1b45c5900a855dcc'
}

export default ROLES;